import React from "react";
import { Danger } from "iconsax-reactjs";
import { HiOutlineX } from "react-icons/hi";
import Loader from "./loader";

export default function DeleteModal({
    isOpen,
    title,
    description,
    confirmText = "Delete",
    cancelText = "Cancel",
    onCancel,
    onConfirm,
    isLoading = false,
}) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black bg-opacity-10">
            <div className="relative bg-white rounded-xl w-full max-w-xl py-4 mx-4">
                {/* top-right “×” */}
                <button
                    onClick={onCancel}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
                >
                    <HiOutlineX size={24} />
                </button>

                {/* header icon + title */}
                <div className="flex items-center gap-4 px-4">
                    <div className="p-4 bg-red-50 rounded-full">
                        <Danger size="24" color="#F04438" />
                    </div>
                    <div className="">
                        <h2 className="text-2xl font-semibold text-[#101828]">{title}</h2>
                        <p className="text-base text-[#475467]">{description}</p>
                    </div>
                </div>

                {/* divider */}
                <hr className="my-4 border-t" />

                {/* footer actions */}
                <div className="flex justify-end gap-4 px-4">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 rounded-lg text-[#101828] hover:bg-gray-50"
                    >
                        {cancelText}
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={isLoading}
                        className="flex items-center justify-center px-4 py-2 rounded-lg bg-[#F04438] text-white hover:bg-red-600 disabled:opacity-50"
                    >
                        {isLoading ? <Loader size="16" /> : confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
}
